import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Shield16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M11.5303 5.53026L10.4696 4.4696L6.99993 7.93927L5.53026 6.4696L4.4696 7.53026L6.99993 10.0606L11.5303 5.53026Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.3031 0.302702C8.10405 0.25294 7.89581 0.25294 7.69676 0.302704L2.19683 1.6777C1.64037 1.81682 1.25 2.3168 1.25 2.89038V11.2128C1.25 11.6574 1.48614 12.0685 1.87016 12.2925L7.37009 15.5009C7.75929 15.7279 8.24056 15.7279 8.62977 15.5009L14.1298 12.2925C14.5139 12.0685 14.75 11.6574 14.75 11.2128V2.89038C14.75 2.3168 14.3596 1.81682 13.8032 1.6777L8.3031 0.302702ZM2.75 3.08557L7.99993 1.77307L13.25 3.08558V11.0692L7.99994 14.1317L2.75 11.0692V3.08557Z'
      fill='currentColor'
    />
  </Svg>
);

Shield16.displayName = 'Shield16';
export default Shield16;
